export const pharmacyConsultationsTranslations = {
    en: {
        // Page Title
        pharmacyConsultationsFor: "Pharmacy Consultations for",
        allCampaigns: "All Campaigns",

        // Table Headers
        srNo: "Sr. No.",
        tokenNo: "Token No.",
        beneficiaryName: "Beneficiary Name",
        medicineName: "Medicine Name",
        quantityGiven: "Quantity Given",
        createdBy: "Created By",
        createdOn: "Created On",
        action: "Action",

        // Buttons
        addConsultation: "Add Consultation",
        profile: "Profile",

        // Status
        campCompleted: "Camp Completed",

        // Drawer Titles
        addPharmacyConsultation: "Add Pharmacy Consultations",
        viewPharmacyConsultation: "View Pharmacy Consultation",

        // Tooltips
        noDosageInfo: "No dosage info",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",
        noValue: "-",

        // Module Name
        pharmacyConsultationsModule: "Pharmacy consultations",
    },
    mr: {
        // Page Title
        pharmacyConsultationsFor: "फार्मसी सल्लामसलत",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        medicineName: "औषधाचे नाव",
        quantityGiven: "दिलेले प्रमाण",
        createdBy: "द्वारे तयार केले",
        createdOn: "वर तयार केले",
        action: "क्रिया",

        // Buttons
        addConsultation: "सल्लामसलत जोडा",
        profile: "प्रोफाइल",

        // Status
        campCompleted: "शिबिर पूर्ण झाले",

        // Drawer Titles
        addPharmacyConsultation: "फार्मसी सल्लामसलत जोडा",
        viewPharmacyConsultation: "फार्मसी सल्लामसलत पहा",

        // Tooltips
        noDosageInfo: "डोस माहिती नाही",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",
        noValue: "-",

        // Module Name
        pharmacyConsultationsModule: "फार्मसी सल्लामसलत",
    }
};
